// Kreator rejestracji przesyłki przychodzącej (biuro podawcze).
// Maszyna stanów wierna kreatorowi z Magistratu (IncomingParcelRegistrationWizard).

export enum WizardStep {
  /** Załączniki: dodanie skanu/pliku, określenie rodzaju, kolejność (drag&drop). */
  Attachments = "attachments",
  /** Stan przesyłki: otwarta? uszkodzona? przekazana bez otwierania? */
  ParcelState = "parcelState",
  /** Główny (pierwszy) załącznik + nadawca + forma doręczenia. */
  MainAttachment = "mainAttachment",
  /** Opis przesyłki: biuro podawcze, skład, dekretujący, dostęp. */
  Description = "description",
}

/** Metadane pojedynczego załącznika (równoległe do listy plików, wg kolejności). */
export interface IAttachmentMeta {
  typeId: number | null;
  title: string;
  signature: string;
  isDigital: boolean;
  digitalMapping: boolean;
}

export const emptyAttachmentMeta = (): IAttachmentMeta => ({
  typeId: null,
  title: "",
  signature: "",
  isDigital: false,
  digitalMapping: false,
});
